"use client";
import * as React from "react";
const SvgBuildFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M15.79 13.078 9.183 6.429c.654-1.68.29-3.653-1.09-5.04C6.642-.074 4.463-.366 2.72.438L5.842 3.58 3.663 5.772.468 2.63c-.871 1.754-.508 3.945.944 5.407 1.38 1.388 3.34 1.753 5.01 1.095l6.609 6.649a.699.699 0 0 0 1.017 0l1.67-1.68c.363-.293.363-.804.072-1.023Z" }));
export {
  SvgBuildFilled as default
};
